// extracted by mini-css-extract-plugin
export default {"loadingDesktop":"SearchResultPanelContent-module__loadingDesktop___2XvY8","loadingMobile":"SearchResultPanelContent-module__loadingMobile___3ue8K"};